import { serviceInstance } from 'libs';
import clean from 'lodash-clean';

export const WalletHistoryLog = ({
  merchantId,
  page,
  from,
  to,
  type,
  params,
}) =>
  serviceInstance.get(
    `/api/merchant/${merchantId}/wallet-history?page=${page}&from=${from}&to=${to}&type=${type}`,
    clean({ params })
  );

  export default {
    fetchWalletHistory: (merchantId, params) =>
    serviceInstance.get(`/api/merchant/${merchantId}/wallet-history`, {
      params,}).then(({data, status}) => ({
      ...data,
      status,
    }))
  }